import React from 'react'
import { connect } from 'react-redux'
import Translation from '../../global/Translation'
import { FormattedHTMLMessage } from 'react-intl'
import backgroundImage from '../../../assets/img/banner-silestone/banner-silestone-background.png'
import { isOnlyUsaSalesOrg } from '../../../store/centers/reducers'
import Button from '../../global/Button'
import LocalizedLink from '../../global/LocalizedLink'

const mapStateToProps = state => {
    return {
        isOnlyUsaSalesOrg: isOnlyUsaSalesOrg(state)
    }
}

class BannerSilestone extends React.Component {
    constructor(props) {
        super(props)

        this.discount = '10%'
    }

    render() {
        const { className, isCheckoutView, isOnlyUsaSalesOrg, isHomeSlideView } = this.props

        const footerDisclaimer = (
            <span>
                <Translation
                    id="silestone_flash_promo_info_discount"
                    defaultMessage="Please note that discount will not be visible in your shopping cart, but it will be reflected in your invoice."
                />
            </span>
        )

        const headerContent = (
            <div>
                <h2>
                    <Translation id="silestone_full_truck_flash_promo" defaultMessage="Silestone® Full truck Flash Promo" />
                </h2>
                <h3>
                    <Translation id="jul_31_ago_8_2025" defaultMessage="Jul. 31st - Aug. 8th 2025" />
                </h3>
            </div>
        )

        const discountContent = (
            <React.Fragment>
                <div className="number-percent">
                    <span>{this.discount}</span>
                </div>
                <div className="text-percent">
                    <div>
                        <span>
                            <Translation id="additional_discount" defaultMessage="additional discount" />
                        </span>
                    </div>
                    <div>
                        <span>
                            <Translation id="and_special_180_day_terms" defaultMessage="and special 180-day terms." />
                        </span>
                    </div>
                </div>
            </React.Fragment>
        )

        const usaFooterContent = (
            <span>
                <FormattedHTMLMessage
                    id="promotion_includes_all_silestone_colors"
                    defaultMessage="Promotion includes all <b>Silestone®</b> colors, thicknesses, and finishes. The possibilities are endless."
                />
            </span>
        )

        const canadaFooterContent = (
            <span>
                <FormattedHTMLMessage
                    id="promotion_includes_all_silestone_colors"
                    defaultMessage="Promotion includes all <b>Silestone®</b> colors, thicknesses, and finishes. The possibilities are endless."
                />
            </span>
        )

        return (
            <React.Fragment>
                {isHomeSlideView ? (
                    <div
                        className="homeslide__banner__silestone"
                        style={{
                            backgroundImage: `url(${backgroundImage})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            height: '100%',
                            width: '100%',
                        }}
                    >
                        <div className="homeslide__banner__silestone--title">{headerContent}</div>
                        <div className="homeslide__banner__silestone--content">{discountContent}</div>
                        <div className="homeslide__banner__silestone--footer">{isOnlyUsaSalesOrg ? usaFooterContent : canadaFooterContent}</div>
                        <div className="homeslide__banner__silestone--discount">{footerDisclaimer}</div>
                        <div className="homeslide__banner__silestone--cta">
                            <LocalizedLink routeId="ROUTE_CATALOG" queryString="?type[0]=SLAB&brand[0]=SILESTONE" params={{ outlet: '' }}>
                                <Button inverted inline className="cta" dataQas="home_hero-banner-silestone-full-truck-button">
                                    <Translation id="buy" defaultMessage="Buy" />
                                </Button>
                           </LocalizedLink>
                            
                        </div>
                    </div>
                ) : !isCheckoutView ? (
                    <div
                        className={`big__banner__silestone ${className}`}
                        style={{
                            backgroundImage: `url(${backgroundImage})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            backgroundPosition: 'bottom'
                        }}
                    >
                        <div className="big__banner__silestone--header">
                            <div className="left-side">
                                {headerContent}
                                <div className="d-none d-md-block">
                                    <div className="left-side--footer">{footerDisclaimer}</div>
                                </div>
                            </div>

                            <div className="right-side">
                                <div className="right-side--content">{discountContent}</div>
                                <div className="right-side--footer">{isOnlyUsaSalesOrg ? usaFooterContent : canadaFooterContent}</div>
                                <div className="d-block d-md-none">
                                    <div className="left-side--footer">{footerDisclaimer}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div
                        className="small__banner__silestone"
                        style={{
                            backgroundImage: `url(${backgroundImage})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover'
                        }}
                    >
                        <div className="small__banner__silestone--title">{headerContent}</div>
                        <div className="small__banner__silestone--content">{discountContent}</div>
                        <div className="small__banner__silestone--footer">{isOnlyUsaSalesOrg ? usaFooterContent : canadaFooterContent}</div>
                        <div className="small__banner__silestone--discount">{footerDisclaimer}</div>
                    </div>
                )}
            </React.Fragment>
        )
    }
}

export default connect(mapStateToProps, null)(BannerSilestone)
